import { render, staticRenderFns } from "./LinkedTagChips.vue?vue&type=template&id=0a026f20&scoped=true"
import script from "./LinkedTagChips.vue?vue&type=script&lang=js"
export * from "./LinkedTagChips.vue?vue&type=script&lang=js"
import style0 from "./LinkedTagChips.vue?vue&type=style&index=0&id=0a026f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a026f20",
  null
  
)

export default component.exports